import {PCFSoftShadowMap, sRGBEncoding, WebGLRenderer} from "three";

/**
 * Создает рендер для canvas
 * @param {canvas} принимает canvas для которого надо создать рендер
 * @returns
 */
export const createRenderer = (canvas: HTMLElement) => {
    const renderer = new WebGLRenderer({
        canvas,
        logarithmicDepthBuffer: true,
        preserveDrawingBuffer: true,
        antialias: true,
        precision: "highp",
    });
    renderer.localClippingEnabled = true;
    renderer.outputEncoding = sRGBEncoding;
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = PCFSoftShadowMap;

    return renderer;
}
